<script lang="ts">import { t, Verbiage } from "@infinitro/content";
import { getIcon } from "../data/icons";
const YoutubeIcon = getIcon("YoutubeIcon");
</script>

{#if typeof YoutubeIcon === 'string'}
	<img src={YoutubeIcon} alt={$t(Verbiage.icon_alt, 'alts')} />
{:else if typeof YoutubeIcon === 'function'}
	<svelte:component this={YoutubeIcon} />
{:else}
	<span>Invalid icon</span>
{/if}

<style>
</style>
